// @ts-strict-ignore
/**
 * Created by claudenbach on 3/2/2017.
 */

import { AppConstants } from '@utils/app.constants';

import { LMCommonUtilService } from '@utils/lm-common-util.service';
import { LMFormatterService } from './lm-formatter.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmProgressFormatter = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  lmCommonUtilService: LMCommonUtilService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {

  if (dataView.isTreeMoreLink) {
    return lmFormatterService.getMoreLink(cell, dataView);
  }

  if (columnDef.displayField.visibility) {
    if (!lmFormatterService.isConditionValid(columnDef.displayField.visibility, dataView)) {
      return '';
    }
  }

  if (lmFormatterService.isTotalRow(dataView)) {
    return lmFormatterService.formatTotalRowColumn(row, cell, value, columnDef, dataView, dataGrid);
  }

  const ranges = columnDef.displayField.ranges;
  const meterRange = columnDef.displayField.meterRangeField || columnDef.displayField.meterRangeValue || 1.0;

  let target; let displayValue; let precision;
  const fieldId = columnDef.displayField.fieldId;
  // Formatter service sanitizes the value
  displayValue = lmFormatterService.getDisplayText(columnDef.displayField, value, dataView, dataGrid.settings.userObject().dataViewSet);

  if (columnDef.displayField.type === AppConstants.PERCENT) {
    precision = dataView.fields[ fieldId ] && dataView.fields[ fieldId ].precision !== undefined
      ? dataView.fields[ fieldId ].precision
      : columnDef.displayField.decSize;
    // displayValue = lmFormatUtilService.percentToDisplay(String(value), {precision: precision});
    target = (value / meterRange).toPrecision(precision);
  } else if (columnDef.displayField.type === AppConstants.BCD) {
    precision = dataView.fields[ fieldId ] && dataView.fields[ fieldId ].precision !== undefined
      ? dataView.fields[ fieldId ].precision
      : columnDef.displayField.decSize;
    // displayValue = lmFormatUtilService.bcdToDisplay(value, {precision: precision, decSize: columnDef.displayField.decSize, displayZero: true});
    target = (value / meterRange).toPrecision(precision);
  } else if (columnDef.displayField.type === AppConstants.NUMERIC) {
    // displayValue = lmFormatUtilService.numericToDisplay(value, { displayZero: true });
    target = (value / meterRange);
  }

  const sohoRanges = [];

  if (ranges) {
    Object.keys(ranges).forEach((item) => {
      const r = ranges[ item ];
      let color = lmCommonUtilService.convertColor({ color: item });
      color = lmCommonUtilService.convertColorToState({ color });

      const min = (typeof r.start === 'string')
        ? dataView.fields[r.start].value
        : r.start;

      const max = (typeof r.end === 'string')
        ? dataView.fields[r.end].value
        : r.end;

      sohoRanges.push( {
        min: ((min / meterRange) * 100),
        max: ((max / meterRange) * 100),
        classes: color,
        text: ''
      });
    });
  }

  const col = {
    ranges: sohoRanges,
    target,
    showPercentText: false,
    text: displayValue
  };

  // console.log('*** lmProgressFormatter: value=' + value + ' displayValue=' + displayValue + ' target=' + target);

  // 2018-01-08 - maf
  // issues with Soho.Formatters.TargetedAchievment
  // 1. percent sign is hard-coded
  // 2. all values regardless type will display as percent
  // 3. it does it's own range checking, hence the need to pass the ranges in its format
  // 4. it does not support all of the features of the Targeted Achievement chart that form uses

  // TODO: CAL - Need to revisit once work on the progress bar in the controls is completed
  // http://jira.infor.com/browse/SOHO-7367
  return Soho.Formatters.TargetedAchievement(row, cell, target, col, dataView, dataGrid);
};
